import { InjectionToken } from '@angular/core';

export const FGA_API_ENDPOINT = new InjectionToken<string>(
  'FGA_API_ENDPOINT'
);